import type { NextPage } from 'next'

const Home: NextPage = () => (<></>)

export default Home
